// extracted by mini-css-extract-plugin
export var columnList = "_em-0";